import ConnectStores from "lib/core/store/components/ConnectStores"
import withPathItemMutations from "../withPathItemMutations"
import PathStepForm from "./PathStepForm"

const mapStateToProps = function (state, ownProps) {
  const { standalone } = ownProps
  const { selection } = state.pathAdminStore.state
  const { unSelectPathItem } = state.pathAdminStore.action

  const fieldValues = {
    verb: selection.assignment_type,
    name: selection.name,
    description: selection.description
  }

  const onSubmit = function (fieldsData, resetForm) {
    if (!fieldsData.name || !fieldsData.verb) {
      console.error("PathStepForm.onSubmit called with invalid form data?")
      return Promise.resolve() // ??
    }

    const data = {
      assignment_type: fieldsData.verb.value.type,
      name: fieldsData.name.value
    }

    if (standalone) {
      data.description = fieldsData.description.value
    }
    return ownProps.savePathItem(data).then(() => unSelectPathItem())
  }

  const onCancel = () => unSelectPathItem()

  const props = _.assign(
    {},
    {
      selection,
      fieldValues,
      onSubmit,
      onCancel
    },
    ownProps
  )
  return props
}

const stores = [{ store: "pathAdmin" }]

const PathStepFormContainer = ConnectStores(
  PathStepForm,
  stores,
  {},
  mapStateToProps
)
PathStepFormContainer.displayName = "PathStepFormContainer"
export default withPathItemMutations(PathStepFormContainer)
